var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19817 1.24693C2.10626 1.15371 1.99673 1.07969 1.87596 1.02917C1.75519 0.978653 1.62559 0.952637 1.49467 0.952637C1.36376 0.952637 1.23416 0.978653 1.11339 1.02917C0.992617 1.07969 0.883092 1.15371 0.791175 1.24693C0.604608 1.43595 0.5 1.69084 0.5 1.95643C0.5 2.22201 0.604608 2.47691 0.791175 2.66593L3.73117 5.63093C3.83251 5.73312 3.95308 5.81424 4.08592 5.86959C4.21877 5.92495 4.36126 5.95345 4.50517 5.95345C4.64909 5.95345 4.79158 5.92495 4.92443 5.86959C5.05727 5.81424 5.17784 5.73312 5.27917 5.63093L8.20917 2.67593C8.39604 2.48687 8.50084 2.23175 8.50084 1.96593C8.50084 1.7001 8.39604 1.44499 8.20917 1.25593C8.11726 1.16271 8.00773 1.08869 7.88696 1.03817C7.76619 0.987653 7.63659 0.961637 7.50567 0.961637C7.37476 0.961637 7.24516 0.987653 7.12439 1.03817C7.00362 1.08869 6.89409 1.16271 6.80217 1.25593L4.50517 3.57393L2.19817 1.24693Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.4955becaf85b06c498b7ef6af4683301.svg";
export { ForwardRef as ReactComponent };